<template>
    <v-dialog max-width="500px" v-model="show" persistent>
        <v-card v-if="data == 'withdraw'">
            <v-card-title class="headline">Withdraw</v-card-title>
            <v-card-text>
                Withdrawing will cause you to leave the game. After leaving,
                the lead researcher will contact you within 24 hours to carry
                out a debriefing.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="show = false">Cancel</v-btn>
                <v-btn text color="primary" @click="withdraw()">Confirm</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="data == 'escape'">
            <v-card-title class="headline">Escape!</v-card-title>
            <v-card-text>
                Are you sure you would like to escape? This will end the game!
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="show = false">Cancel</v-btn>
                <v-btn text color="primary" @click="escape()">Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: Boolean,
        data: String
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        }
    },
    methods: {
        escape() {
            this.$socket.client.emit("hacker_action", {
                action: "escape"
            });
            this.show = false;
        },
        withdraw() {
            this.$socket.client.emit("hacker_action", {
                action: "withdraw"
            });
            this.show = false;
        }
    }
}
</script>
